export const themePage = {
    barChart: 'Time Series of Patent Applications',
    pieChart: 'Ratio of Patent Applications by Technology Classification (IPC)',
    buildNum: 'Time Series of Inventors',
    applyNum: 'Time Series of Patent Applications by Applied Region',
    applyNumSubtext: 'Region',
    countryNum: 'Time Series of Patents Applications  by Applied Country (Organization)',
    countryNumSubtext: 'Country',
    businessNum: 'Time Series of Companies',
    ipcName: 'Technology Classifications (IPC)',
    ipcLegendOthers: 'Others (other than the Top 10 IPCs)',
    ipcNameSubtext: 'Technology Classifications',
    cluster: 'Cluster & Value Chain',
    company: 'Inter-company Analysis',
    country: 'Country Analysis',
    chart: 'Theme Overview',
    year: 'Year',
    numberofinventors: 'Number of inventors',
    ipcnamePie: 'Technology Classifications (IPC)',
    patentcount: 'Number of Patent Applications',
    patentratio: 'Ratio of Patent Applications',
    inventorcount: 'Number of Inventors',
    companycount: 'Number of Companies',
    chart1Title: 'Strategic Options',
    xSelect1: 'Score (Technological Progress)',
    xSelect2: 'Growth Rate of Score',
    ySelect1: 'Market Expectation',
    ySelect1_log: 'Market Expectation (Log-Transformed)',
    ySelect2: 'Startup Market Expectation',
    ySelect2_log: 'Startup Market Expectation (Log-Transformed)',
    ySelect3: 'Growth Rate of Market Expectation',
    ySelect3_2: 'Growth Rate of Startup Market Expectation',
    ySelect4: 'Business Scale',
    ySelect4_log: 'Business Scale (Log-Transformed)',
    bSelect1: 'Number of Patent Applications',
    bSelect2: 'Number of Forward Citations',
    bSelect3: 'Fixed Value',
    xLabel: 'X Axis',
    yLabel: 'Y Axis',
    bLabel: 'Metrics',
    table1Column1: 'Cluster ID',
    table1Column2: 'Cluster Name',
    table1Column3: 'Domain',
    table1Column4: 'Score',
    table1Column5: 'Score Growth Rate',
    table1Column6: 'Market Expectation',
    table1Column7: 'Growth Rate of Market Expectation',
    table1Column8: 'Startup Market Expectation',
    table1Column9: 'Growth Rate of Startup Market Expectation',
    table1ColumnScoreDeviation: 'Score (Deviation Value)',
    table1ColumnMarketExpectation: 'Market Expectation (Deviation Value)',
    table1ColumnStartupMarketExpectation: 'Startup Market Expectation (Deviation Value)',
    noTable: 'Select a cluster and its details will be displayed',
    selectHistory: 'Select from the history',
    favoriteTableColumn1: 'Company Name',
    selectHistory1: 'Selection Date and Time',
    selectHistory2: 'Cluster ID',
    selectHistory3: 'Cluster Name',
    lineCountry: 'Country',
    lineCompanyName: 'Company Name',
    linePatentCount: 'Patent Count',
    lineYear: 'Year',
    companyIP: 'IP Information',
    seachTheme: 'Please type in English',
    companyDownload: 'Download Patent List',
    companyChart: 'Time Series of Patent Applications',
    compantChartSelect: 'Theme Name',
    compantGeneralInfo: 'General Information',
    compantGeneralInfoYear: 'Year of Incorporation',
    compantGeneralInfoLocation: 'Location',
    compantGeneralInfoNaceCode: 'NACE Code',
    compantGeneralInfoNaceLabel: 'NACE Label',
    compantGeneralInfoOwner: 'Ultimate Owner Company',
    compantGeneralInfoParent: 'Parent Company',
    compantGeneralInfoSubs: 'Subsidiary',
    compantGeneralInfoWeb: 'Website',
    compantGeneralInfoBussiness: 'Business Overview',
    compantFinanceTitle: 'Financial Information',
    compantFinanceCo1: 'Sales [m USD]',
    compantFinanceCo2: 'Profits [m USD]',
    compantFinanceCo3: 'R&D Expenses [m USD]',
    compantFinanceCo4: 'Catpital [m USD]',
    compantFinanceCo5: 'Total Assets [m USD]',
    compantFinanceCo6: 'Listed Market (Ticker) ',
    compantFinanceCo7: 'Investors',
    compantFinanceCo8: 'EBITDA [th USD]',
    compantFinanceCo9: 'EBIT [th USD]',
    compantFinanceCo10: 'Pre-Tax Profit [th USD]',
    compantFinanceCo11: 'Profit After Tax [th USD]',
    compantFinanceCo12: "Shareholders' Equity [th USD]",
    compantFinanceCo13: 'Market Capitalization [th USD]',
    compantFinanceCo14: 'Number of Employees',
    compantFinanceCo15: 'Corporate Value [th USD]',
    compantFinanceCo16: 'EPS [USD]',
    compantFinanceCo17: 'CFPS',
    compantFinanceCo18: 'DPS [USD]',
    compantFinanceCo19: 'BPS [USD]',
    compantFinanceCo20: 'Net Assets [th USD]',
    compantFinanceCo21: 'Stage Information',
    compantFinanceCoSc: 'Securities Code',
    clusterid: 'Cluster ID',
    ipccode: 'Main IPC',
    ipcother: 'Other IPC',
    publicationnumber: 'Publication Number',
    applicationyear: 'Application Year',
    factorloadquantity: 'Factor Load Quantity',
    numberofforwardcitations: 'Forward Citations',
    title: 'Title',
    inventor: 'Inventor',
    companyname: 'Patent Owner',
    downloadTips: 'Select a cluster to download',
    downloadHelpMsg: "Select either each cluster or all the cluster's patent applications to download.",
    table5IpcName: 'Company Name (Top 10)'
}
